import {
  ActionsPopup,
  AssessmentCard,
  assessmentFilterTypes,
  AssessmentTopicPopup,
  deserify,
  FilterSortPopup,
  getLocalStorage,
  getMediaBasePath,
  IClassAndSubjectSelected,
  IStyles,
  Loader,
  NoContentCard,
  pxToRem,
  pxTovW,
  roundingAssessmentNumber,
  SelectMenu,
  ShimmerManageHwCard,
  theme,
  useCommonServiceClientContext,
  useFeatureEnabled,
} from '@geneo2-web/shared-ui';
import {
  Chip,
  Divider,
  Grid,
  Pagination,
  Typography,
  useMediaQuery,
} from '@mui/material';
import { Box, Container, display, SxProps } from '@mui/system';
import React, { useEffect, useState, useRef } from 'react';
import { useAppSelector, useAppDispatch } from '../../../reduxStore/reduxHooks';
import { ProfileRolesEnum } from '@protos/user_management/ums.db_pb';
import {
  setAssessmentData,
  setSelectedChapter,
  setSelectedTopic,
  resetSelectedChapter,
  resetSelectedTopic,
  setCourseIndexInfo,
  setAssessmentCreationType,
  setAssessmentLibraryFilter,
  setFAQuestionModuleMap,
  setQPGContent,
  setFAContent,
  setFALibraryChoiceCreation,
} from '../reducer/assessmentFlow.slice';
import {
  AssessmentEnum,
  MarkingSchemeEnum,
  ModeOfConductionEnum,
  TaskCreationStatusEnum,
  TaskEnum,
} from '@protos/learning_management/lms.db_pb';
import {
  DifficultyLevelEnum,
  Module_ModuleCategoryEnum,
} from '@protos/content_management/content.db_pb';
import {
  setClassAndSubjectInfo,
  setToastInfo,
  setToastInfoV2,
} from '../../Home/reducer/homeDashboard.slice';
import {
  setCreatedAssessmentStatus,
  setCustomHomework,
  setFetchedAssessmentDetails,
  setModuleFilteredQuestions,
  setQuestionsCount,
  setSelectedTasksInfo,
} from '../../Assessment/reducer/assessmentFlow.slice';
import {
  ASSESSMENT_CURRENT,
  ASSESSMENT_REVIEW,
  DIAGNOSTIC,
  FA_ASSIGN_SETTINGS,
  FORMATIVE,
  HOME,
  HOMEWORK,
  HOMEWORK_CURRENT_CUSTOM,
  QPG,
  QPG_ASSESSMENT_PUBLISH,
  QPG_ASSESSMENT_PUBLISHED,
  QPG_ASSESSMENT_REVIEW_PAPER,
} from '../../../routeHandling/RoutesNomenclature';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  AssessmentContent,
  AssessmentsByType,
  AssessmentTask,
} from '@protos/learning_management/lms.assessment.common.apis_pb';
import { useGlobalContext } from '../../../app/Context/GlobalContextProvider';
import { interactionEvent } from '../../Auth/auth.events';
import { useDownloadContext } from '../../../app/Context/DownloadContextProviderV2';
import { Feature } from '@protos/school_management/school.db_pb';
import { convertToSequenceInfo } from '../Common/ReviewAssessment/functions';
import { ConnectError } from '@bufbuild/connect';
import { buildTaskInfoModels } from '../QuestionPaperGeneratorV2/QPGv2.utils';
import { getSubjectListForAssessmentCard } from '../utils/assessment.utils';

interface IAssessmentTypes {
  name: string;
  id: AssessmentEnum;
}

const styles: IStyles = {
  root: {
    // width: '100vw',
    cursor: 'pointer',
    // paddingLeft: { xs: pxToRem(20), lg: pxTovW(241) },
    paddingX: { xs: pxToRem(20), md: pxTovW(20), lg: pxTovW(80) },
    paddingTop: { xs: pxToRem(20), lg: pxTovW(40) },
    paddingBottom: { xs: pxToRem(50), lg: pxTovW(40) },
    // paddingRight: { xs: pxToRem(20), lg: pxTovW(241) },
    boxSizing: 'border-box',
    overflowX: 'hidden',
    overflowY: 'hidden',
  },
  pagination: {
    width: 'max-content',
    margin: 'auto',
    mt: { xs: pxToRem(20), md: pxTovW(30) },
  },
  container: {
    display: 'flex',
    justifyContent: 'center',
  },
  inputFeild: {
    backgroundColor: 'red',
    display: 'flex',
    height: { xs: pxToRem(50), md: pxTovW(56) },
    borderRadius: { xs: pxToRem(10), md: pxTovW(15) },
    border: '1px solid #CCE6FE',
    width: { xs: pxToRem(311), lg: pxTovW(457) },
    justifyContent: 'space-around',
    alignItems: 'center',
  },
  inputBox: {
    display: 'flex',
    justifyContent: { xs: 'space-between', md: 'center' },
    gap: { xs: pxToRem(10), md: pxTovW(10) },
  },
  inputFeildBox: {
    paddingTop: { xs: pxToRem(20), md: pxTovW(5) },
    paddingLeft: { xs: pxToRem(10), md: pxTovW(70) },
  },
  selectContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: { xs: pxToRem(6), md: pxTovW(12) },
  },
};

const AssesmentLibrary: React.FC = () => {
  const {
    LmsAssessmentCommonAPIServiceV1ClientWithStatusCodeHandler,
    LmsAssessmentTeacherAPIServiceV1WithStatusCodeHandler,
    LmsAssessmentTeacherAPIServiceV6WithStatusCodeHandler,
  } = useCommonServiceClientContext();
  const navigate = useNavigate();
  const location = useLocation();
  const pathSegments = location.pathname.split('/');
  const { isOffline } = useDownloadContext();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<any>(null);
  const [pageNumber, setPageNumber] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalCount, setTotalCount] = useState<number | undefined>();
  const [currentPage, setCurrentPage] = useState(1); // Current page
  const [paginatedData, setPaginatedData] = useState<AssessmentTask[]>(); // Data for current page
  const itemsPerPage = 24; // Items per page
  const [selectedHomework, setSelectedAssessment] = useState<
    AssessmentTask | undefined
  >();
  const [chapterListPopup, setChapterListPopup] = useState(false);
  const dispatch = useAppDispatch();
  const [selectedAssessmentInfo, setSelectedAssessmentInfo] = useState<
    | {
        assessmentId: number;
        assessmentType: AssessmentEnum;
        modeOfSelection: 'delete' | 'copy';
      }
    | undefined
  >(undefined);

  const { setSelectedFunction } = useGlobalContext();
  // const isMounted = useRef(false);
  const {
    assesment_flow_data,
    chapter_topic_data,
    selected_chapter,
    selected_topic,
    assesment_creation_type,
    assessment_library_filter,
    fa_library_choice_creation,
  } = useAppSelector((state) => state.assessment);

  const { manage_mode_of_conduction } = useAppSelector(
    (state) => state.manageHomework
  );
  const { class_subject_info } = useAppSelector((state) => state.homeDashboard);
  const { user_info } = deserify(useAppSelector((state) => state.auth));

  const isQPGFeatureEnabled = useFeatureEnabled(
    user_info?.schoolDetails[0]?.featuresPlanInfo,
    Feature.QUESTION_PAPER_GENERATOR
  );

  const { ContentCommonAPIServiceV1ClientWithStatusCodeHandler } =
    useCommonServiceClientContext();
  const teacher_id = getLocalStorage('userId');

  const [allSubjects, setAllSubjects] = useState<IClassAndSubjectSelected[]>(
    []
  );
  const [selectedclassandsubject, setSelectedclassandsubject] = useState(
    (class_subject_info?.classname ?? '') +
      (class_subject_info?.section ?? '') +
      ' ' +
      (class_subject_info?.subject ?? '')
  );
  const [selectedsubjectId, setSelectedSubjectId] = useState(
    class_subject_info?.subjectId
  );
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const calculatePaginationInfo = (
    assessmentData: AssessmentsByType | undefined
  ): void => {
    const countInPagination =
      assessmentData?.assessmentListInfo?.countInPagination || 1;
    const hwCount = assessmentData?.assessmentListInfo?.homeworksCount || 0;
    const assessmentCount =
      assessmentData?.assessmentListInfo?.totalAssessmentsCount || 0;

    // Set totalCount if assessmentCount is greater than 0
    if (assessmentCount > 0) {
      setTotalCount(assessmentCount);
    } else {
      setTotalCount(undefined);
    }

    // // Calculate totalPages based on assessmentType
    // const totalPages =
    //   assessmentType === AssessmentEnum.ASSESSMENT_HOMEWORK
    //     ? Math.ceil(hwCount / countInPagination)
    //     : Math.ceil(assessmentCount / countInPagination);

    // Calculate totalPages based on itemsPerPage
    const totalPages = Math.ceil(assessmentCount / countInPagination);
    setTotalPages(totalPages);
  };

  // ----------------------------------------------------

  const onDeleteClick = async (assessment: AssessmentTask) => {
    if (
      assessment.assessmentType === AssessmentEnum.ASSESSMENT_QUESTION_PAPER
    ) {
      setSelectedAssessmentInfo({
        assessmentId: assessment.assessmentId,
        assessmentType: assessment.assessmentType,
        modeOfSelection: 'delete',
      });
    }
    await interactionEvent({
      context:
        assessment.assessmentType === AssessmentEnum.ASSESSMENT_QUESTION_PAPER
          ? 'Question_paper'
          : 'Assessment',
      name: 'DELETE',
      pathSegments: pathSegments,
      isOffline: isOffline,
    });
  };

  // ----------------------------------------------------

  const deleteAssessment = async (
    assessmentId: number,
    assessmentType: AssessmentEnum
  ) => {
    try {
      setLoading(true);
      const response =
        await LmsAssessmentTeacherAPIServiceV1WithStatusCodeHandler.deleteTeacherCreatedAssessment(
          {
            assessmentId: assessmentId,
            teacherId: user_info?.teacherProfileId,
          }
        );
      setPaginatedData(
        paginatedData?.filter((item) => item.assessmentId !== assessmentId)
      );
      setLoading(false);
      dispatch(
        setToastInfo({
          variant: 'success',
          label: 'Assessment Deleted Successfully',
          open: true,
        })
      );
    } catch (err) {
      console.log(err);
      setLoading(false);
      dispatch(
        setToastInfo({
          variant: 'error',
          label: 'Error occurred while deleting assessment',
          open: true,
        })
      );
    }
  };

  // ----------------------------------------------------

  const assessmentCreationSubmitV6 = async (
    assessmentData: AssessmentContent
  ) => {
    const metaInfo = assessmentData?.multiSubjectSections;
    try {
      setLoading(true);
      const assessmentCreationSubmitResponse =
        await LmsAssessmentTeacherAPIServiceV6WithStatusCodeHandler.assessmentCreationSubmit(
          {
            sourceGeneoAssessmentId: Number(
              assessmentData.assessment?.assessmentId
            ),
            teacherId: user_info?.teacherProfileId,
            classId: assessmentData.assessment?.classId,
            creationStatus: TaskCreationStatusEnum.TASK_CREATION_STATUS_DRAFT,
            multiSubjectSectionMetaInfo: metaInfo,
            sectionId: assessmentData?.assessment?.sectionId,
            subjectIds: metaInfo?.map((section) => section.subjectId) ?? [],
            taskName: assessmentData?.assessment?.assessmentTitle + ' (Copy)',
            taskType: TaskEnum.TASK_MULTI_SUBJECT_QUESTION_PAPER_CUSTOM,
            instructions: assessmentData?.assessment?.assessmentInstructions,
            questionModuleMap:
              assessmentData?.questionsSequenceInfo?.questionModuleMap,
            selectedTasksInfo: buildTaskInfoModels(metaInfo),
            chapterIdsInfo:
              assessmentData?.assessment?.taskMetaInfo?.chapterInfo
                ?.chapterTopicsInfo,
          }
        );

      if (assessmentCreationSubmitResponse.status === 200) {
        navigate(
          `${QPG_ASSESSMENT_PUBLISH}?assessment_id=${assessmentCreationSubmitResponse.data?.assessment?.assessmentId}`,
          { state: { fromAssessmentLibrary: true } }
        );
      } else {
        dispatch(
          setToastInfoV2({
            label: 'Error while creating a copy of Question Paper',
            variant: 'error',
            open: true,
          })
        );
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log('error:', error);
      let message = 'Error while creating a copy of Question Paper';
      if (error instanceof ConnectError) {
        message = error.rawMessage?.replace(/.*\]\s*/, '').trim();
      }
      dispatch(
        setToastInfoV2({
          label: message,
          variant: 'error',
          open: true,
        })
      );
    }
  };

  // ----------------------------------------------------

  const onCopyClick = async (assessment: AssessmentTask) => {
    if (
      assessment.assessmentType === AssessmentEnum.ASSESSMENT_QUESTION_PAPER
    ) {
      setSelectedAssessmentInfo({
        assessmentId: assessment.assessmentId,
        assessmentType: assessment.assessmentType,
        modeOfSelection: 'copy',
      });
    }
    await interactionEvent({
      context:
        assessment.assessmentType === AssessmentEnum.ASSESSMENT_QUESTION_PAPER
          ? 'Question_paper'
          : 'Assessment',
      name: 'CREATE_COPY',
      pathSegments: pathSegments,
      isOffline: isOffline,
    });
  };

  // ----------------------------------------------------

  const copyAssessment = async (
    assessmentId: number,
    assessmentType: AssessmentEnum
  ) => {
    if (assessmentType === AssessmentEnum.ASSESSMENT_QUESTION_PAPER) {
      try {
        setLoading(true);
        const response =
          await LmsAssessmentCommonAPIServiceV1ClientWithStatusCodeHandler.fetchAssessmentContent(
            {
              assessmentId: assessmentId,
              personId: user_info?.teacherProfileId,
              personType: ProfileRolesEnum.PROFILE_ROLE_TEACHER,
            }
          );
        const qpgAssessmentTask = response?.data?.assessment;
        const questionSectionMetaInfo =
          response?.data?.questionsSequenceInfo?.questionSectionMetaInfo;

        if (
          response?.data &&
          response?.data?.assessment?.taskType ===
            TaskEnum.TASK_MULTI_SUBJECT_QUESTION_PAPER_CUSTOM
        ) {
          await assessmentCreationSubmitV6(response?.data);
          return;
        }

        const assessmentCreationSubmitResponse =
          await LmsAssessmentTeacherAPIServiceV6WithStatusCodeHandler.assessmentCreationSubmit(
            {
              sourceGeneoAssessmentId: assessmentId,
              teacherId: user_info?.teacherProfileId,
              subjectId: qpgAssessmentTask?.subjectId,
              sectionId: qpgAssessmentTask?.sectionId,
              taskName: (qpgAssessmentTask?.assessmentTitle || '') + ' (Copy)',
              category: Module_ModuleCategoryEnum.MODULE_CATEGORY_BOOK,
              instructions: qpgAssessmentTask?.assessmentInstructions,
              creationStatus: TaskCreationStatusEnum.TASK_CREATION_STATUS_DRAFT,
              taskType: TaskEnum.TASK_QUESTION_PAPER_CUSTOM,
              chapterIdsInfo:
                qpgAssessmentTask?.taskMetaInfo?.chapterInfo?.chapterTopicsInfo,
              questionModuleMap: response.data?.questionModuleMap,
              questionSectionMetaInfo: (questionSectionMetaInfo || []).filter(
                (info) =>
                  info.sectionQuestionsInfo.length > 0 &&
                  info.sectionQuestionsInfo.some(
                    (ques) =>
                      ques.questionId !== undefined ||
                      (Array.isArray(ques.alternateQuestions) &&
                        ques.alternateQuestions?.length > 0)
                  )
              ),
            }
          );
        if (assessmentCreationSubmitResponse.data?.assessment?.assessmentId) {
          navigate(
            `${QPG}${ASSESSMENT_REVIEW}/${assessmentCreationSubmitResponse.data?.assessment?.assessmentId}`,
            {
              state: {
                redirectionPath: location.pathname,
              },
            }
          );
        }
        setLoading(false);
        dispatch(
          setToastInfo({
            variant: 'success',
            label: 'Assessment Copied Successfully',
            open: true,
          })
        );
      } catch (err) {
        console.log(err);
        setLoading(false);
        dispatch(
          setToastInfo({
            variant: 'error',
            label: 'Error occurred while copying assessment',
            open: true,
          })
        );
      }
    }
  };

  // ----------------------------------------------------

  // need this when pagination implemented
  // useEffect(() => {
  //   console.log(selected_topic, 'selected_topic');
  //   const fetchData = async () => {
  //     try {
  //       setLoading(true); // Start loading
  //       // First API call: Fetch assessments
  //       const assessmentResult = await fetchAssessmentsByModule(
  //         selected_chapter?.chapterId,
  //         selected_topic?.topicId
  //       );
  //       if (assessmentResult) {
  //         dispatch(setAssessmentData(assessmentResult.data));
  //         calculatePaginationInfo(assessmentResult?.data, assessmentType);
  //       }
  //     } catch (error) {
  //       setError(error); // Handle error
  //     } finally {
  //       setLoading(false); // Stop loading
  //     }
  //   };

  //   if (isMounted.current) {
  //     fetchData();
  //   } else {
  //     isMounted.current = true;
  //   }
  // }, [selected_chapter, selected_topic]); // Runs when either selected_chapter or selected_topic changes
  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true); // Start loading
        // Define the fetchAssessmentsByModule function inside useEffect
        // First API call: Fetch assessments
        const assessmentResult = await fetchAssessmentsByModule(
          selected_chapter?.chapterId,
          selected_topic?.topicId,
          assessment_library_filter?.assessmentType?.id
        );

        if (assessmentResult) {
          const fullData = assessmentResult?.data?.assessments || [];

          // Set full data in Redux or other stores
          dispatch(setAssessmentData(assessmentResult.data));
          calculatePaginationInfo(assessmentResult?.data);

          // Initialize paginated data for the first page
          const initialData = fullData.slice(0, itemsPerPage);
          setPaginatedData(initialData);
        }
      } catch (error) {
        setError(error); // Handle error
      } finally {
        setLoading(false); // Stop loading
      }
    };
    fetchData();
  }, [
    selectedsubjectId,
    selected_chapter,
    selected_topic,
    pageNumber,
    assessment_library_filter,
  ]); // Runs when either selected_chapter or selected_topic changes

  const handlePageChange = (
    event: React.ChangeEvent<unknown>,
    page: number
  ) => {
    setCurrentPage(page);

    // Update paginated data for the selected page
    const fullData = assesment_flow_data?.assessments || [];
    const startIndex = (page - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    const pageData = fullData.slice(startIndex, endIndex);
    setPaginatedData(pageData);
  };

  const handleBackButtonClick = () => {
    if (location.state?.redirectionPath) {
      if (location.state.redirectionPath.includes(location.pathname)) {
        navigate(HOME);
      } else {
        navigate(location.state.redirectionPath);
      }
    } else if (
      location.state?.fromQPG ||
      location.state?.fromQPGPublished ||
      location.state?.fromQPGPublish ||
      location.state?.saveToLibraryFromFADraft
    ) {
      navigate(HOME);
    } else {
      navigate(-1);
    }
  };

  useEffect(() => {
    if (location.state?.from) {
      if (
        location.state.from.includes(`${QPG}${ASSESSMENT_REVIEW}`) ||
        location.state.from.includes(`${QPG_ASSESSMENT_PUBLISHED}`)
      ) {
        const selectedAssessmentType = assessmentFilterTypes.find(
          (option) => option.id === AssessmentEnum.ASSESSMENT_QUESTION_PAPER
        );
        if (selectedAssessmentType) {
          // setSearchByAssessType(selectedAssessmentType);
          dispatch(
            setAssessmentLibraryFilter({
              ...assessment_library_filter,
              assessmentType: selectedAssessmentType,
            })
          );
        }
      }
    }
    setSelectedFunction(() => handleBackButtonClick);
    return () => {
      setSelectedFunction(null);
    };
  }, [location.state?.from]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true); // Start loading
        setError(null); // Reset previous error if any
        setPageNumber(1);
        if (assesment_flow_data) {
          calculatePaginationInfo(assesment_flow_data);
        }
        const chapterTopicData =
          await ContentCommonAPIServiceV1ClientWithStatusCodeHandler.fetchCourseIndexInfo(
            {
              personId: BigInt(teacher_id),

              personType: ProfileRolesEnum.PROFILE_ROLE_TEACHER,
              subjectId: fa_library_choice_creation?.subject_id
                ? Number(fa_library_choice_creation.subject_id)
                : Number(selectedsubjectId),
            }
          );
        if (chapterTopicData) {
          dispatch(setCourseIndexInfo(chapterTopicData?.data));
        }
      } catch (error) {
        dispatch(
          setToastInfo({
            label: 'Error fetching Chapter Topic Data',
            variant: 'error',
            open: true,
          })
        );
      } finally {
        setLoading(false); // Stop loading
      }
    };
    fetchData();
  }, [selectedsubjectId]);

  // ----------------------------------------------------

  const fetchAssessmentsByModule = async (
    chapterId?: number,
    topicId?: number,
    assessmentType?: AssessmentEnum
  ) => {
    let personType;
    if (assessment_library_filter?.CreatedBy === 'You') {
      personType = ProfileRolesEnum.PROFILE_ROLE_TEACHER;
    } else if (assessment_library_filter?.CreatedBy === 'Geneo') {
      personType = ProfileRolesEnum.PROFILE_ROLE_GENEO_ADMIN;
    } else {
      personType = ProfileRolesEnum.PROFILE_ROLE_UNDEFINED;
    }

    let statusType: TaskCreationStatusEnum | undefined;
    if (assessment_library_filter?.assessmentCreationStatus === 'Draft') {
      statusType = TaskCreationStatusEnum.TASK_CREATION_STATUS_DRAFT;
    } else if (
      assessment_library_filter?.assessmentCreationStatus === 'Published'
    ) {
      statusType = TaskCreationStatusEnum.TASK_CREATION_STATUS_APPROVED;
    }

    const response =
      await LmsAssessmentCommonAPIServiceV1ClientWithStatusCodeHandler.fetchAssessmentsByModule(
        {
          personId: teacher_id,
          personType: personType,
          subjectId: fa_library_choice_creation?.subject_id
            ? Number(fa_library_choice_creation.subject_id)
            : selectedsubjectId,
          modeOfConduction:
            fa_library_choice_creation?.conduction_mode ||
            manage_mode_of_conduction,
          chapterId: chapterId ? Number(chapterId) : undefined,
          topicId: topicId ? Number(topicId) : undefined,
          assessmentType: assessmentType,
          assessmentCreationStatus:
            assessmentType === AssessmentEnum.ASSESSMENT_QUESTION_PAPER
              ? statusType
              : undefined,
          pageNumber: pageNumber,
          createdByTeacherIds:
            personType === ProfileRolesEnum.PROFILE_ROLE_TEACHER
              ? user_info?.teacherProfileId
                ? [user_info?.teacherProfileId]
                : undefined
              : personType === ProfileRolesEnum.PROFILE_ROLE_GENEO_ADMIN
              ? [BigInt(1)]
              : undefined,
          isMultiSubjectLibraryCreationFlow:
            !!fa_library_choice_creation?.subject_id,
          markingSchemeType: fa_library_choice_creation?.marking_scheme,
        }
      );
    return response; // Return the fetched data or handle it here
  };

  // ----------------------------------------------------

  const sortFunction = async (sortValue: string) => {
    if (assesment_flow_data?.assessments && paginatedData) {
      const temp = assesment_flow_data?.assessments?.slice(); // Create a shallow copy for immutability
      let sortedData = [];

      switch (sortValue) {
        case 'Alphabetical: A to Z':
          sortedData = temp.sort((a, b) =>
            a.assessmentTitle.localeCompare(b.assessmentTitle)
          );
          break;
        case 'Alphabetical: Z to A':
          sortedData = temp.sort((a, b) =>
            b.assessmentTitle.localeCompare(a.assessmentTitle)
          );
          break;
        case 'Newest':
          sortedData = temp.sort((a, b) => {
            const timeA = a?.lastModifiedTime?.seconds || 0; // Use as-is, could be BigInt or number
            const timeB = b?.lastModifiedTime?.seconds || 0; // Use as-is, could be BigInt or number
            return timeB > timeA ? 1 : timeB < timeA ? -1 : 0; // Compare values
          });
          break;
        case 'Oldest':
          sortedData = temp.sort((a, b) => {
            const timeA = a?.lastModifiedTime?.seconds || 0; // Use as-is, could be BigInt or number
            const timeB = b?.lastModifiedTime?.seconds || 0; // Use as-is, could be BigInt or number
            return timeA > timeB ? 1 : timeA < timeB ? -1 : 0; // Compare values
          });
          break;
        case 'Duration: Longest to Shortest':
          sortedData = temp.sort(
            (a, b) => (b.estimatedTimeInMin || 0) - (a.estimatedTimeInMin || 0)
          );
          break;
        case 'Duration: Shortest to Longest':
          sortedData = temp.sort(
            (a, b) => (a.estimatedTimeInMin || 0) - (b.estimatedTimeInMin || 0)
          );
          break;
        case 'Difficulty: Easy to Hard':
          sortedData = temp.sort(
            (a, b) =>
              difficultyLevelSort(a.difficultyLevel) -
              difficultyLevelSort(b.difficultyLevel)
          );
          break;
        case 'Difficulty: Hard to Easy':
          sortedData = temp.sort(
            (a, b) =>
              difficultyLevelSort(b.difficultyLevel) -
              difficultyLevelSort(a.difficultyLevel)
          );
          break;
        default:
          sortedData = temp;
      }
      const startIndex = (currentPage - 1) * 24;
      const endIndex = startIndex + 24;
      const currentPageData = sortedData.slice(startIndex, endIndex);

      // Update paginatedData and store
      setPaginatedData(currentPageData);
      dispatch(
        setAssessmentData({
          ...assesment_flow_data,
          assessments: sortedData, // Update the full sorted data in the store
        })
      );
      // setPaginatedData(sortedData);
      // dispatch(
      //   setAssessmentData({
      //     ...assesment_flow_data,
      //     assessments: sortedData,
      //   })
      // );
    }
    await interactionEvent({
      context: 'Sort_by',
      name: sortValue.toUpperCase().replace(/\s+/g, '_').replace(/[:.]/g, ''),
      pathSegments: pathSegments,
      isOffline: isOffline,
    });
  };

  // ----------------------------------------------------

  const cardClickHandler = async (cardDetails: AssessmentTask) => {
    if (!!fa_library_choice_creation?.subject_id) {
      dispatch(
        setFALibraryChoiceCreation({
          ...fa_library_choice_creation,
          subject_id: undefined,
          chosen_assessment: cardDetails,
        })
      );
      navigate(location.state.redirectionPath);
      return;
    }

    if (
      cardDetails.taskType === TaskEnum.TASK_MULTI_SUBJECT_QUESTION_PAPER_CUSTOM
    ) {
      getMultiSubjectQuestionPaperDetails({
        assessmentId: cardDetails.assessmentId,
        cardType: 'qpg',
      });
    } else if (
      cardDetails.taskType ===
      TaskEnum.TASK_MULTI_SUBJECT_FORMATIVE_ASSESSMENT_CUSTOM
    ) {
      getMultiSubjectQuestionPaperDetails({
        assessmentId: cardDetails.assessmentId,
        cardType: 'fa',
      });
    } else if (
      cardDetails.assessmentType === AssessmentEnum.ASSESSMENT_QUESTION_PAPER
    ) {
      navigate(`${QPG}${ASSESSMENT_REVIEW}/${cardDetails.assessmentId}`, {
        state: {
          redirectionPath: location.pathname,
        },
      });
    } else if (cardDetails.moduleId) {
      await getHomeworkDetails(
        cardDetails.assessmentId,
        cardDetails.moduleId.toString()
      );
    }
    await interactionEvent({
      context: 'Ready_Made_Assessment',
      name: 'ASSESSMENT_OPEN',
      pathSegments: pathSegments,
      isOffline: isOffline,
    });
  };

  // ----------------------------------------------------

  const getMultiSubjectQuestionPaperDetails = async (props: {
    assessmentId: number;
    cardType: 'qpg' | 'fa';
  }) => {
    const { assessmentId, cardType } = props;

    const fetchAssessmentContentResponse =
      await LmsAssessmentCommonAPIServiceV1ClientWithStatusCodeHandler.fetchAssessmentContent(
        {
          personId: user_info?.teacherProfileId,
          personType: ProfileRolesEnum.PROFILE_ROLE_TEACHER,
          assessmentId: assessmentId,
        }
      );

    if (fetchAssessmentContentResponse.data) {
      if (cardType === 'qpg') {
        dispatch(setQPGContent(fetchAssessmentContentResponse.data));
        if (
          fetchAssessmentContentResponse.data.assessment?.taskCreationStatus ===
          TaskCreationStatusEnum.TASK_CREATION_STATUS_APPROVED
        ) {
          navigate(
            `${QPG_ASSESSMENT_PUBLISHED}?assessment_id=${assessmentId}`,
            {
              state: { fromAssessmentLibrary: true },
            }
          );
        } else {
          navigate(`${QPG_ASSESSMENT_PUBLISH}?assessment_id=${assessmentId}`, {
            state: { fromAssessmentLibrary: true },
          });
        }
      } else if (cardType === 'fa') {
        dispatch(setFAContent(fetchAssessmentContentResponse.data));
        navigate(FA_ASSIGN_SETTINGS + `?assessment_id=${assessmentId}`, {
          state: { fromAssessmentLibrary: true },
        });
      }
    }
  };

  // ----------------------------------------------------

  const getHomeworkDetails = async (homeworkId: number, moduleId: string) => {
    try {
      const response =
        await LmsAssessmentCommonAPIServiceV1ClientWithStatusCodeHandler.fetchAssessmentContent(
          {
            personId: teacher_id,
            personType: ProfileRolesEnum.PROFILE_ROLE_TEACHER,
            assessmentId: homeworkId,
            modeOfConduction: manage_mode_of_conduction,
          }
        );
      if (response.data) {
        const assessmentData = response.data;
        dispatch(
          setCreatedAssessmentStatus(
            assessmentData.assessment?.taskCreationStatus
          )
        );
        dispatch(setFAQuestionModuleMap(assessmentData.questionModuleMap));
        dispatch(
          setModuleFilteredQuestions({
            questions: assessmentData.assessmentContent,
          })
        );
        dispatch(setFetchedAssessmentDetails(assessmentData.assessment));
        const sequenceInfo = convertToSequenceInfo(
          assessmentData.questionsSequenceInfo
        );
        if (sequenceInfo) {
          dispatch(setSelectedTasksInfo(sequenceInfo));
        }
        dispatch(setQuestionsCount());
        if (
          assessmentData?.assessment?.taskType ===
          TaskEnum.TASK_HOMEWORK_TEACHER_CUSTOM
        ) {
          const customHw = structuredClone(assessmentData.assessment);
          customHw.assessmentId = 0;
          dispatch(setCustomHomework(customHw));
          navigate(`${HOMEWORK}${HOMEWORK_CURRENT_CUSTOM}/${moduleId}`);
        } else if (
          assessmentData.assessment?.assessmentType ===
          AssessmentEnum.ASSESSMENT_HOMEWORK
        ) {
          dispatch(
            setAssessmentCreationType({
              asessmentType: AssessmentEnum.ASSESSMENT_HOMEWORK,
              modeOfConduction: assessmentData.assessment.modeOfConduction,
              creationType: 'Readymade',
            })
          );
          navigate(`${HOMEWORK}${ASSESSMENT_CURRENT}/${moduleId}`);
        } else if (
          assessmentData.assessment?.assessmentType ===
          AssessmentEnum.ASSESSMENT_FORMATIVE_ASSESSMENT
        ) {
          dispatch(
            setAssessmentCreationType({
              asessmentType: AssessmentEnum.ASSESSMENT_FORMATIVE_ASSESSMENT,
              modeOfConduction: assessmentData.assessment.modeOfConduction,
              creationType: 'Readymade',
              markingScheme:
                manage_mode_of_conduction ===
                ModeOfConductionEnum.MODE_OF_CONDUCTION_GENEO_CLICKER
                  ? MarkingSchemeEnum.MARKING_SCHEME_GENEO
                  : assessmentData.assessment.markingSchemeType ===
                    MarkingSchemeEnum.MARKING_SCHEME_JEE
                  ? MarkingSchemeEnum.MARKING_SCHEME_JEE
                  : MarkingSchemeEnum.MARKING_SCHEME_GENEO,
            })
          );
          navigate(`${FORMATIVE}${ASSESSMENT_CURRENT}/${moduleId}`);
        } else if (
          assessmentData.assessment?.assessmentType ===
          AssessmentEnum.ASSESSMENT_DIAGNOSTIC_ASSESSMENT
        ) {
          dispatch(
            setAssessmentCreationType({
              asessmentType: AssessmentEnum.ASSESSMENT_DIAGNOSTIC_ASSESSMENT,
              modeOfConduction: assessmentData.assessment.modeOfConduction,
              creationType: 'Readymade',
            })
          );
          navigate(`${DIAGNOSTIC}${ASSESSMENT_CURRENT}/${moduleId}`);
        }
      } else {
        dispatch(
          setToastInfo({
            label: 'Something went wrong!',
            variant: 'error',
            open: true,
          })
        );
      }
    } catch (err) {
      console.log(err);
      dispatch(
        setToastInfo({
          label: 'Something went wrong!',
          variant: 'error',
          open: true,
        })
      );
    }
  };
  // Helper function for sorting difficulty levels
  const difficultyLevelSort = (level: number) => {
    switch (level) {
      case DifficultyLevelEnum.DIFFICULTY_LEVEL_HIGH:
        return 3;
      case DifficultyLevelEnum.DIFFICULTY_LEVEL_MEDIUM:
        return 2;
      case DifficultyLevelEnum.DIFFICULTY_LEVEL_LOW:
        return 1;
      default:
        return 0; // Undefined or unknown
    }
  };
  useEffect(() => {
    if (user_info?.teachClassSubjects?.length) {
      const arr = user_info?.teachClassSubjects.flatMap((classInfo) =>
        classInfo.subjects.map((subject) => ({
          classname: classInfo.className,
          section: classInfo.sectionName,
          sectionId: classInfo.sectionId,
          subjectId: subject.subjectId,
          subject: subject.subjectName,
          icon: subject.iconUrl
            ? getMediaBasePath(subject.iconUrl, 'schoolnetStaticAssetBucket')
            : '',
          color: subject.textColor,
          bookId: subject.bookId,
          classId: classInfo.classId,
          isClickerSupported: classInfo.isClickerSupported ? true : false,
        }))
      );
      setAllSubjects([...arr]);
    }
  }, [user_info?.teachClassSubjects?.length]);

  const ShimmerComponent = () => {
    return (
      <Grid container rowGap={3} sx={{ width: { md: pxTovW(1100) } }}>
        {Array.from({ length: 12 }, (_, index) => (
          <Grid item xs={12} md={4} key={index}>
            <ShimmerManageHwCard key={index} />
          </Grid>
        ))}
      </Grid>
    );
  };
  const ChapterListPopupHandler = (assessment: AssessmentTask) => {
    setSelectedAssessment(assessment);
    setChapterListPopup(true);
  };
  return (
    <Box sx={styles.root}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: { xs: pxToRem(20), md: pxTovW(45), lg: pxTovW(30) },
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', lg: 'row' },
            justifyContent: { xs: 'center', md: 'center' },
            alignItems: { md: 'center', lg: 'center' },
            textAlign: { xs: 'center', lg: 'start' },
            gap: { xs: pxToRem(4), md: pxTovW(10), lg: pxTovW(10) },
          }}
        >
          <Typography variant="h1" fontWeight={700}>
            Browse Assessment Library
          </Typography>
          {totalCount && totalCount > 0 && (
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                background: '#E0F1FF',
                border: '1px solid #007CDC',
                p: {
                  xs: `${pxToRem(4)} ${pxToRem(5)}`,
                  md: `${pxTovW(8)} ${pxTovW(17)}`,
                },
                borderRadius: {
                  xs: pxToRem(5),
                  md: pxTovW(15),
                  lg: pxTovW(16),
                },
                marginX: { xs: 'auto', md: 0 },
                '& .MuiTypography-root > span': {
                  color: '#007CDC',
                },
              }}
            >
              <Typography
                variant={isMobile ? 'h4' : 'h2'}
                fontWeight={600}
                fontFamily={'poppins'}
              >
                <span>{roundingAssessmentNumber(totalCount)}</span> ready-made
                assessments available
              </Typography>
            </Box>
          )}
        </Box>
        <Box
          sx={{
            display: 'flex',
            width: { xs: '100%' },
            // backgroundColor: 'red',
            alignItems: 'center',
            justifySelf: 'stretch',
            flexWrap: 'wrap',
            justifyContent: {
              xs: 'space-between',
              md: 'space-between',
              lg: 'center',
            },
            gap: { xs: pxToRem(10), md: pxTovW(15), lg: pxTovW(15) },
            // marginLeft: { lg: pxTovW(60) },
          }}
        >
          <Box sx={styles.selectContainer}>
            <Typography variant="h4">Choose Class & Subject</Typography>
            <SelectMenu
              disabled={!!location.state?.chooseFromLibrary}
              placeholder="select"
              value={selectedclassandsubject}
              onChange={async (value: string) => {
                setSelectedclassandsubject(value);
                const classSubjectObj = allSubjects?.find(
                  (e) => e.classname + e.section + ' ' + e.subject === value
                );
                if (classSubjectObj) {
                  setSelectedSubjectId(classSubjectObj?.subjectId);
                }
                dispatch(setClassAndSubjectInfo(classSubjectObj));
                dispatch(resetSelectedChapter());
                dispatch(resetSelectedTopic());
                await interactionEvent({
                  context: 'Choose_Class_&_Subject',
                  name: value.toUpperCase().replace(/\s+/g, '_'),
                  pathSegments: pathSegments,
                  isOffline: isOffline,
                });
              }}
              optionList={
                allSubjects?.map((e) => {
                  return {
                    name: e.classname + e.section + ' ' + e.subject,
                    id: e.subjectId,
                    nonEditableItem:
                      manage_mode_of_conduction ===
                      ModeOfConductionEnum.MODE_OF_CONDUCTION_GENEO_CLICKER
                        ? !e.isClickerSupported
                        : false,
                  };
                }) || []
              }
              rootStyles={{
                width: { xs: pxToRem(152), md: pxTovW(540), lg: pxTovW(230) },
                height: { xs: pxToRem(30), md: pxTovW(75), lg: pxTovW(56) },
              }}
              // disabled={true}
            />
          </Box>

          <Box sx={styles.selectContainer}>
            <Typography variant="h4">Select Chapter</Typography>
            <SelectMenu
              placeholder="select"
              value={
                selected_chapter?.chapterTitle
                  ? `${
                      selected_chapter.chapterNo
                        ? `${selected_chapter.chapterNo}. `
                        : ''
                    }${selected_chapter.chapterTitle}`
                  : ''
              }
              clearIcon={true}
              onChange={async (value: string) => {
                // Find the chapter object by matching the selected title
                if (!value) {
                  dispatch(resetSelectedChapter());
                  dispatch(resetSelectedTopic());
                } else {
                  const selectedChapterObj = chapter_topic_data?.chapters?.find(
                    (chapter) =>
                      `${chapter.chapterNo}. ${chapter.chapterTitle}` === value
                  );
                  dispatch(resetSelectedTopic());
                  if (selectedChapterObj) {
                    const chapterData = {
                      chapterTitle: selectedChapterObj.chapterTitle,
                      chapterId: selectedChapterObj.chapterId,
                      chapterNo: selectedChapterObj.chapterNo,
                    };
                    dispatch(setSelectedChapter(chapterData));
                    setPageNumber(1); // Reset page number when chapter changes
                  }
                }

                if (value.trim() !== '') {
                  await interactionEvent({
                    context: 'Select_Chapter',
                    name: value
                      .toUpperCase()
                      .replace(/\s+/g, '_')
                      .replace(/[:.]/g, ''),
                    pathSegments: pathSegments,
                    isOffline: isOffline,
                  });
                }
              }}
              optionList={
                chapter_topic_data?.chapters?.map((chapter) => {
                  return {
                    name: `${chapter.chapterNo}. ${chapter.chapterTitle}`,
                    id: chapter.chapterId,
                  };
                }) || []
              }
              rootStyles={{
                width: { xs: pxToRem(152), md: pxTovW(540), lg: pxTovW(280) },
                height: { xs: pxToRem(30), md: pxTovW(75), lg: pxTovW(56) },
              }}
            />
          </Box>

          <Box sx={styles.selectContainer}>
            <Typography variant="h4">Select Topic</Typography>
            <SelectMenu
              placeholder="select"
              value={
                selected_topic?.topicTitle ? selected_topic?.topicTitle : ''
              }
              disabled={selected_chapter ? false : true}
              clearIcon={true}
              onChange={async (value: string) => {
                // setSelectedTopic(value);
                if (!value) {
                  dispatch(resetSelectedTopic());
                } else {
                  const selectedTopicObj = chapter_topic_data?.chapters
                    .find(
                      (chapter) =>
                        Number(chapter.chapterId) ===
                        Number(selected_chapter?.chapterId)
                    )
                    ?.topics?.find((topic) => topic.topicTitle === value);

                  if (selectedTopicObj) {
                    const topicData = {
                      topicTitle: selectedTopicObj.topicTitle,
                      topicId: selectedTopicObj.topicId,
                    };
                    dispatch(setSelectedTopic(topicData));
                    setPageNumber(1); // Reset page number when topic changes
                  }
                }
                if (value.trim() !== '') {
                  await interactionEvent({
                    context: 'Select_Topic',
                    name: value.toUpperCase().replace(/\s+/g, '_'),
                    pathSegments: pathSegments,
                    isOffline: isOffline,
                  });
                }
              }}
              optionList={
                chapter_topic_data?.chapters
                  ?.find((chapter) => {
                    return (
                      Number(chapter.chapterId) ===
                      Number(selected_chapter?.chapterId)
                    );
                  })
                  ?.topics?.map((topic) => {
                    return {
                      name: topic.topicTitle,
                      id: topic.topicId,
                    };
                  }) || []
              }
              rootStyles={{
                width: { xs: pxToRem(152), md: pxTovW(540), lg: pxTovW(280) },
                height: { xs: pxToRem(30), md: pxTovW(75), lg: pxTovW(56) },
              }}
            />
          </Box>
          <Box sx={styles.selectContainer}>
            <Typography variant="h4">Choose Assessment Type</Typography>
            <SelectMenu
              disabled={!!location.state?.chooseFromLibrary}
              placeholder="select"
              value={
                assessment_library_filter?.assessmentType
                  ? assessment_library_filter?.assessmentType.name
                  : ''
              }
              onChange={async (value: string) => {
                const selectedAssessmentType = assessmentFilterTypes.find(
                  (option) => option.name === value
                );
                setPageNumber(1);
                dispatch(
                  setAssessmentLibraryFilter({
                    ...assessment_library_filter,
                    assessmentCreationStatus: '',
                    assessmentType: selectedAssessmentType,
                  })
                );
                // setSearchByAssessType(selectedAssessmentType);

                if (value.trim() !== '') {
                  await interactionEvent({
                    context: 'Choose_Assessment_Type',
                    name: value.toUpperCase().replace(/\s+/g, '_'),
                    pathSegments: pathSegments,
                    isOffline: isOffline,
                  });
                }
              }}
              optionList={
                isQPGFeatureEnabled
                  ? assessmentFilterTypes
                  : assessmentFilterTypes.filter(
                      (option) => option.name !== 'Question Paper'
                    )
              }
              rootStyles={{
                width: { xs: pxToRem(152), md: pxTovW(540), lg: pxTovW(230) },
                height: { xs: pxToRem(30), md: pxTovW(75), lg: pxTovW(56) },
              }}
              clearIcon={!!location.state?.chooseFromLibrary ? false : true}
            />
          </Box>
          {assessment_library_filter?.assessmentType?.name ===
          'Question Paper' ? (
            <Box sx={styles.selectContainer}>
              <Typography variant="h4">Status</Typography>
              <SelectMenu
                placeholder="select"
                value={
                  assessment_library_filter?.assessmentCreationStatus || ''
                }
                clearIcon
                onChange={async (value: string) => {
                  setPageNumber(1);
                  dispatch(
                    setAssessmentLibraryFilter({
                      ...assessment_library_filter,
                      assessmentCreationStatus: value,
                    })
                  );
                  // setAssessmentCreationStatus(value);
                  await interactionEvent({
                    context: 'Status',
                    name: value.toUpperCase(),
                    pathSegments: pathSegments,
                    isOffline: isOffline,
                  });
                }}
                optionList={[
                  {
                    name: 'Draft',
                    id: 1,
                  },
                  {
                    name: 'Published',
                    id: 2,
                  },
                ]}
                rootStyles={{
                  width: { xs: pxToRem(152), md: pxTovW(540), lg: pxTovW(230) },
                  height: { xs: pxToRem(30), md: pxTovW(75), lg: pxTovW(56) },
                }}
              />
            </Box>
          ) : (
            <></>
          )}
          <Box sx={styles.selectContainer}>
            <Typography variant="h4">Created By</Typography>
            <SelectMenu
              placeholder="select"
              value={assessment_library_filter?.CreatedBy || ''}
              clearIcon
              onChange={async (value: string) => {
                setPageNumber(1);
                dispatch(
                  setAssessmentLibraryFilter({
                    ...assessment_library_filter,
                    CreatedBy: value,
                  })
                );
                if (value.trim() !== '') {
                  await interactionEvent({
                    context: 'Created_by',
                    name: value.toUpperCase().replace(/\s+/g, '_'),
                    pathSegments: pathSegments,
                    isOffline: isOffline,
                  });
                }
              }}
              optionList={[
                {
                  name: 'You',
                  id: 1,
                },
                {
                  name: 'Geneo',
                  id: 2,
                },
              ]}
              rootStyles={{
                width: { xs: pxToRem(152), md: pxTovW(540), lg: pxTovW(230) },
                height: { xs: pxToRem(30), md: pxTovW(75), lg: pxTovW(56) },
              }}
            />
          </Box>
          <Box
            sx={{
              height: 'max-content',
              width: { xs: 'max-content', md: pxTovW(540), lg: pxTovW(115) },
              display: 'flex',
              marginTop: 'auto',

              alignItems: { xs: 'flex-end', md: 'flex-end', lg: 'flex-end' },
              justifyContent: { xs: 'end', lg: 'start' },
              marginBottom: { xs: 0, md: 0, lg: pxTovW(5) },
              // marginX: { xs: 'auto', md: 0 }
            }}
          >
            <FilterSortPopup
              iconName="Sort"
              title="Sort By"
              options={[
                'Alphabetical: A to Z',
                'Alphabetical: Z to A',
                // 'Popularity',
                'Newest',
                'Oldest',
                'Duration: Longest to Shortest',
                'Duration: Shortest to Longest',
                'Difficulty: Easy to Hard',
                'Difficulty: Hard to Easy',
              ]}
              sortFunction={sortFunction}
            />
          </Box>
        </Box>
      </Box>
      {/* {totalCount && totalCount > 0 && selection && (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            paddingTop: { xs: pxToRem(10), md: pxTovW(30) },
          }}
        >
          <Typography variant="h2">
            Based on your selection, {roundingAssessmentNumber(totalCount)}{' '}
            ready-made assessments were found
          </Typography>
        </Box>
      )} */}
      <Box
        sx={{
          paddingTop: { xs: pxToRem(20), md: pxTovW(40) },
          paddingBottom: { xs: pxToRem(20), md: pxTovW(40) },
          display: 'flex',
          justifyContent: 'center',
        }}
      >
        {loading === true ? (
          // <Loader />
          // <ShimmerComponent />
          <Loader />
        ) : error === true ? (
          <NoContentCard variant="error" icon="error" text="Error Occured" />
        ) : assesment_flow_data &&
          assesment_flow_data?.assessments.length <= 0 ? (
          <NoContentCard
            variant="info"
            icon="cards"
            text="No Assessments Found"
          />
        ) : (
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: { xs: pxToRem(20), md: pxTovW(20) },
            }}
          >
            <Grid
              container
              // columns={{ xs: 1, md: 3 }}
              rowGap={3}
              // columnGap={'26px'}
              sx={{ width: { md: pxTovW(1800), lg: pxTovW(1430) } }}
            >
              {/* {assesment_flow_data?.assessments?.map((card, index) => (
                <Grid item xs={12} md={4} key={index}>
                  <AssessmentCard
                    homework={card}
                    onClick={() => cardClickHandler(card)}
                    assessCardType="library"
                  />
                </Grid>
              ))} */}
              {paginatedData?.map((card, index) => (
                <Grid item xs={12} md={4} key={index}>
                  <AssessmentCard
                    homework={card}
                    onClick={() => cardClickHandler(card)}
                    chapterListPopupHandler={ChapterListPopupHandler}
                    assessCardType="Draft"
                    onDeleteClick={() => onDeleteClick(card)}
                    onCopyClick={() => onCopyClick(card)}
                    subjectList={getSubjectListForAssessmentCard(
                      card,
                      user_info?.teachClassSubjects
                    )}
                  />
                </Grid>
              ))}
            </Grid>
            <Pagination
              page={pageNumber}
              count={totalPages}
              color="secondary"
              onChange={async (
                event: React.ChangeEvent<unknown>,
                page: number
              ) => {
                setPageNumber(page);
              }}
              sx={styles.pagination}
            />
          </Box>
        )}
      </Box>

      <AssessmentTopicPopup
        assessment={selectedHomework}
        open={chapterListPopup}
        handleClose={() => setChapterListPopup(false)}
      />

      <ActionsPopup
        open={!!selectedAssessmentInfo}
        handleClose={() => setSelectedAssessmentInfo(undefined)}
        fontSmall
        iconName="delete"
        popupText={`Are you sure you want to ${
          selectedAssessmentInfo?.modeOfSelection === 'delete'
            ? 'delete'
            : 'copy'
        } ${
          selectedAssessmentInfo?.assessmentType ===
          AssessmentEnum.ASSESSMENT_HOMEWORK
            ? 'Homework'
            : 'Assessment'
        } ?`}
        yesClickHandler={(ev?: React.MouseEvent) => {
          ev?.stopPropagation();
          if (selectedAssessmentInfo?.modeOfSelection === 'delete') {
            deleteAssessment(
              selectedAssessmentInfo.assessmentId,
              selectedAssessmentInfo.assessmentType
            );
          } else if (selectedAssessmentInfo?.modeOfSelection === 'copy') {
            copyAssessment(
              selectedAssessmentInfo.assessmentId,
              selectedAssessmentInfo.assessmentType
            );
          }
          setSelectedAssessmentInfo(undefined);
        }}
        noClickHandler={(ev?: React.MouseEvent) => {
          ev?.stopPropagation();
          setSelectedAssessmentInfo(undefined);
        }}
      />
    </Box>
  );
};

export default AssesmentLibrary;
